import { useState, useEffect } from 'react';
import { API } from '../utils/axiosConfig';
import {
	Container,
	FormCheck,
	FormSelect,
	Form,
	Button,
	Modal,
	Card,
	Alert,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faUserPlus } from '@fortawesome/free-solid-svg-icons';

const ViewPNC = () => {
	const api = API();
	const [pncs, setPNCs] = useState([]);
	const [pncFilter, setPNCFilter] = useState('all');
	const [filteredPNCs, setFilteredPNCs] = useState([]);
	const [submission, setSubmission] = useState();
	const [showModal, setShowModal] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [errorMessage, setErrorMessage] = useState('');

	//Initial loading of all PNC's
	useEffect(() => {
		api
			.get('/pnc/getPNCs')
			.then((res) => {
				if (res.status === 200) {
					// console.log(res.data);
					setPNCs(res.data.pncs.sort(sortLastName));
					setFilteredPNCs(res.data.pncs.sort(sortLastName)); //inital setting is all pncs
				}
			})
			.catch((err) => console.log(err));
	}, []);

	function sortLastName(a, b) {
		if (a.lastName > b.lastName) {
			return 1;
		}
		if (b.lastName > a.lastName) {
			return -1;
		}
		return 0;
	}

	//Handle the click to view a Preliminary Information Submission
	const getSubmission = (e) => {
		const practiceArea = e.target.name;
		const pncID = e.target.value;
		api
			.post('/pnc/getPreliminaryInformation', { practiceArea, pncID })
			.then((res) => {
				if (res.status === 200) {
					console.log(res);
					setSubmission(res.data.submission);
				}
			})
			.catch((err) => console.log(err));
	};

	//Open the viewing modal when the submission is retrieved.
	useEffect(() => {
		if (submission) {
			setShowModal(true);
		}
	}, [submission]);

	//Filter the PNC's when radio button changes
	useEffect(() => {
		if (pncFilter === 'all') {
			setFilteredPNCs([...pncs]);
		}
		if (pncFilter === 'willstrusts') {
			setFilteredPNCs(
				pncs.filter((pnc) => pnc.practiceAreas.includes('willstrusts'))
			);
		}
		if (pncFilter === 'probate') {
			setFilteredPNCs(
				pncs.filter((pnc) => pnc.practiceAreas.includes('probate'))
			);
		}
	}, [pncFilter]);

	const handleModalClose = () => {
		setShowModal(false);
		setErrorMessage('');
		setSuccessMessage('');
	};

	const createUserAccount = () => {
		api
			.post('/users/createUserFromPNC', {
				address: submission.address,
				city: submission.city,
				zipcode: submission.zipcode,
				phone: submission.zipcode,
				pncID: submission.pncID,
			})
			.then((res) => {
				if (res.status === 200) {
					console.log(res);
					setSuccessMessage('User Created Successfully');
				}
			})
			.catch((err) => {
				//TODO: set an error notice
				setErrorMessage(err.response.data.message);
			});
	};

	//Sort PNC's by those that have filled out a Preliminary Information form, Probate vs. Wills, PNC's that are already Clients

	return (
		<div className="page">
			<Container className="mt-4 mb-4">
				<Card>
					<Card.Header>
						<h4>Preliminary Information Submissions</h4>
					</Card.Header>
					<Card.Body>
						<Form.Label>All: </Form.Label>
						<FormCheck
							className="ms-2"
							inline
							type="radio"
							name="practicearea"
							value="all"
							defaultChecked
							onChange={() => setPNCFilter('all')}
						/>
						<Form.Label>Probate: </Form.Label>
						<FormCheck
							className="ms-2"
							inline
							type="radio"
							name="practicearea"
							value="probate"
							onChange={() => setPNCFilter('probate')}
						/>
						<Form.Label>Wills & Trusts: </Form.Label>
						<FormCheck
							className="ms-2"
							inline
							type="radio"
							name="practicearea"
							value="willstrusts"
							onChange={() => setPNCFilter('willstrusts')}
						/>
						<hr />
						{filteredPNCs.map((pnc, i) => {
							return (
								<div key={i}>
									<h5>
										{pnc.lastName}, {pnc.firstName}
									</h5>
									<div className="d-flex justify-content-between">
										<div>
											{pnc.practiceAreas.includes('probate') &&
												(pncFilter === 'probate' || pncFilter === 'all') && (
													<Button
														variant="primary"
														className="me-2"
														onClick={getSubmission}
														name="probate"
														value={pnc._id}
													>
														View Probate Submission
													</Button>
												)}
											{pnc.practiceAreas.includes('willstrusts') &&
												(pncFilter === 'willstrusts' ||
													pncFilter === 'all') && (
													<Button
														variant="secondary"
														onClick={getSubmission}
														name="willstrusts"
														value={pnc._id}
													>
														View Wills & Trusts Submission
													</Button>
												)}
										</div>
									</div>
									<hr />
								</div>
							);
						})}
					</Card.Body>
				</Card>
			</Container>
			{submission && (
				<Modal show={showModal} onHide={handleModalClose}>
					<Modal.Header closeButton>
						{submission.practiceArea === 'probate'
							? 'Probate'
							: 'Wills & Trusts'}
					</Modal.Header>
					{!errorMessage && !successMessage && (
						<Modal.Body>
							{Object.keys(submission).map((prop, i) => {
								if (submission[prop].hasOwnProperty('question')) {
									if (typeof submission[prop].answer === 'string') {
										return (
											<div key={i}>
												<label>
													<strong>{submission[prop].question}</strong>
												</label>
												<div>{submission[prop].answer}</div>
											</div>
										);
									} else {
										//Must aggregate the result of a check box set
										let answer = '';
										const keys = Object.keys(submission[prop].answer);
										//each answer is {text, value}
										keys.forEach((k, i) => {
											if (submission[prop].answer[k].value === true) {
												if (answer !== '') {
													answer += `, ${submission[prop].answer[k].text}`;
												} else {
													answer += `${submission[prop].answer[k].text}`;
												}
											}
										});
										return (
											<div key={i}>
												<label>
													<strong>{submission[prop].question}</strong>
												</label>
												<div>{answer}</div>
											</div>
										);
									}
								}
							})}
						</Modal.Body>
					)}
					{errorMessage && (
						<Modal.Body>
							<Alert variant="danger">{errorMessage}</Alert>
						</Modal.Body>
					)}
					{successMessage && (
						<Modal.Body>
							<Alert variant="success">{successMessage}</Alert>
						</Modal.Body>
					)}
					<Modal.Footer>
						<div>
							<Button onClick={createUserAccount}>
								<FontAwesomeIcon icon={faUserPlus} /> Create User Account
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			)}
		</div>
	);
};
export default ViewPNC;
